import { useState } from "react";
import { useNavigate } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { useGetFinanceSurveyQuery } from "../../../../api/financeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { filterSurveyStatus } from "./index.js";
import Pagination from "../../../Components/Pagination/Pagination";

const AdministrativeFeedbackSurvey = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [purpose, setPurpose] = useState(1);

  const navigate = useNavigate();

  const { data, isLoading } = useGetFinanceSurveyQuery({
    CategoryType: purpose,
    Status: filter,
    PageSize: pageSize,
    PageNumber: currentPage,
    StartDate: startDate,
    EndDate: endDate,
  });
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.result?.length > 0 ? (
    data?.result?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.createdBy}</td>
          <td>{item?.categoryTypeName}</td>
          <td>{item?.questionCount}</td>
          <td>{FormatDateTime(item?.createdDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view`}>
              {[
                {
                  name: "View",
                  action: () => handleView(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Survey Found
      </td>
    </tr>
  );
     const purposes = [
    { name: "Business Development", filter: 1 },
    { name: "Relationship Management", filter: 2 },
  ];
  return (
    <RouteLayout navHidden={true}>
      <PageStyle hasBack={false} demoTitle={"Feedback Survey (Administration)"} hasTopPageDemo>
        <div className="flex justify-between items-center">
          <form className={DashboardStyle.dashboard_filter}>
             <ProDropFilter
                          filter={purpose}
                          setFilter={setPurpose}
                          name={"Category"}
                          filterBy={purposes}
                        />
            <SearchFilter
              value={searchText}
              text={(searchText) => setSearchText(searchText)}
            />
            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              normalDate
            />
            <ProDropFilter
              filter={filter}
              setFilter={setFilter}
              name={"Status"}
              filterBy={filterSurveyStatus}
            />
          </form>
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                <th>S/N</th>
                <th style={{ cursor: "pointer" }}>Created By</th>
                <th style={{ cursor: "pointer" }}>Category</th>
                <th style={{ cursor: "pointer" }}>Question Count</th>
                <th style={{ cursor: "pointer" }}>Date Created</th>
                <th style={{ cursor: "pointer" }}>Approval Status</th>
                <th style={{ cursor: "pointer" }}>Actions</th>
              </tr>
            </thead>
            <tbody>{tableContent}</tbody>
          </Table>
        </div>
        <Pagination
          last_page={data?.totalPages}
          present_page={data?.currentPage}
          totalRows={data?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setCurrentPage(page)}
        />
      </PageStyle>
    </RouteLayout>
  );
};

export { AdministrativeFeedbackSurvey };
